import {ValidationErrorRow, validationErrorRowFactory} from "./validation-error";
import {toList, toString} from "../helpers/helpers";

const DEFAULT_MESSAGE = "";

export interface MultiValidationErrorRow {
  row: string;
  type: string;
  index: string;
  header: string;
  error: ValidationErrorRow[];
}

export function multiValidationErrorRowFactory(json: any) {
  json = json || {};

  const type = toString(json.type);
  const index = toString(json.index);

  const header = json.header ? toString(json.header) : makeReadableRowHeader(type, index);

  return {
    row: toString(json.row),
    type,
    index,
    header,
    error: toList(validationErrorRowFactory, json.error),
  } as MultiValidationErrorRow;
}

function makeReadableRowHeader(type: string = "row", index: string) {
  const str = type.replace(/^./, a => a.toUpperCase()).replace(/-(.)/g, (a, b) => ` ${b}`.toUpperCase());
  if (+index === -1) return str;
  return `${str} ${index}`;
}

export class MultiValidationError extends Error {
  validationErrors: ValidationErrorRow[];
  validationErrorRows: MultiValidationErrorRow[];
  message: string;
  name: string = "MultiValidationError";

  static check(obj: any): boolean {
    if (!obj) return false;

    return Object.prototype.hasOwnProperty.call(obj, "validationErrors") &&
      obj["validationErrors"] !== null &&
      obj["validationErrors"] !== undefined &&
      obj["validationErrors"] instanceof Array &&
      Object.prototype.hasOwnProperty.call(obj, "validationErrorRows") &&
      obj["validationErrorRows"] !== null &&
      obj["validationErrorRows"] !== undefined &&
      obj["validationErrorRows"] instanceof Array;
  }

  constructor(json: any) {
    super("");
    Object.setPrototypeOf(this, MultiValidationError.prototype);
    if (!MultiValidationError.check(json)) throw new Error("Not a MultiValidationError");

    this.message = json["message"] || DEFAULT_MESSAGE;

    this.validationErrors = toList(validationErrorRowFactory, json["validationErrors"]);

    this.validationErrorRows = toList(multiValidationErrorRowFactory, json["validationErrorRows"]);
  }

  get stack(): any {
    return [
      ...this.validationErrors.map(error => error.processed),
      ...this.validationErrorRows.map(row => row.error.map(error => error.processed).join("\n")),
    ].join("\n");
  }
}
